import groq from 'groq';

export const ICONS_LIST = groq`
  "variant": coalesce(variant, 'lg'),
  icons[]{
    _key,
    label,
    asset -> {
      url
    }
  }
`;

export const ICONS_LIST_BLOCK = groq`
  _type == 'iconsList' => @-> {
    ${ICONS_LIST}
  }
`;
